<template>
  <b-card :class="vertical ? '' : 'mb-1'">
    <b-card-title class="font-title mb-1">
      <feather-icon class="mr-1" icon="DropletIcon" size="18" />
      相对湿度监测（24小时）
    </b-card-title>
    <div
      id="hours_48_params_humi"
      class="w-100"
      style="height: calc(100% - 3rem)"
    ></div>
  </b-card>
</template>

<script>
import { Mix } from "@antv/g2plot";
import { onMounted, onUnmounted, reactive, ref } from "@vue/composition-api";
import { getHours48Params } from "@/api/hjj2";
import { routerParams } from "@/libs/utils/routerParams";
import { momentFmt } from "@/libs/utils/moment";

export default {
  name: "Hours48ParamsHumi",
  props: ["vertical"],
  setup(props) {
    const vertical = props.vertical;
    const project_id = routerParams("project_id");
    const interval = ref(null);
    const event = reactive({
      chart: null,
      data: [],
    });
    const chart_init_hours_48_params_humi = (data = []) => {
      if (event.chart) {
        event.chart.destroy();
        event.chart = null;
      }
      const chart = new Mix("hours_48_params_humi", {
        legend: {
          position: "top",
          itemName: {
            style: {
              fill: "#808695",
            },
          },
        },
        plots: [
          {
            type: "line",
            options: {
              data: data,
              xField: "time",
              yField: "value",
              seriesField: "name",
              color: ({ name }) => {
                if (name === "室外") {
                  return "#1890ff";
                }
                return "#28c76f";
              },
              xAxis: {
                label: {
                  formatter: (text) => {
                    return text.split(" ")[1];
                    // console.log('text',text)
                    // return text.replaceAll(" ", "\n").replaceAll("00:00", "00").replaceAll(".000000", "");
                  },
                },
              },
              yAxis: {
                title: {
                  text: "湿度 (%)",
                  style: {
                    fill: "#808695",
                  },
                },
                // line: {
                //   style: {
                //     stroke: "#82868b",
                //     lineWidth: 1,
                //     opacity: 0.7,
                //   },
                // },
                // grid: {
                //   line: {
                //     style: {
                //       stroke: "#82868b",
                //       lineWidth: 1,
                //       lineDash: [2, 8],
                //       strokeOpacity: 0.7,
                //       shadowColor: "#82868b",
                //       cursor: "pointer",
                //     },
                //   },
                // },
              },
              isStack: false,
              smooth: true,

              meta: {
                time: {
                  alias: "时间",
                },
              },
            },
          },
        ],
      });
      chart.render();
      event.chart = chart;
    };
    const fetchHours48Params = () => {
      getHours48Params({
        project_id: project_id,
        meter_code: ["06750343HUMI", "00fd6cdfb6fb57e7room1realHumidity"],
      }).then((res) => {
        let params = {};
        let key = "";
        res.data.map((item) => {
          let name = "室内";
          if (item.meter_code === "06750343HUMI") {
            name = "室外";
          }
          let time = momentFmt(item.time, "YYYY-MM-DD HH:00");
          key = item.meter_code + "_" + time;
          params[key] = {
            name: name,
            time: time,
            value: item.value,
            meter_code: item.meter_code,
            unit: item.unit,
          };
        });
        params = Object.values(params);
        // console.log('humi_params', params)
        event.data = params;
        if (event.chart) {
          chart_init_hours_48_params_humi(params);
        }
      });
    };

    onMounted(() => {
      fetchHours48Params();
      chart_init_hours_48_params_humi();
      interval.value = setInterval(() => {
        fetchHours48Params();
      }, 1000 * 60 * 60);
    });

    onUnmounted(() => {
      clearInterval(interval.value);
    });
  },
};
</script>

<style scoped></style>
